import React from 'react';
import NinetiesNailsCaseStudy from '../components/NinetiesNailsCaseStudy';
import MoreStoriesNotice from '../components/MoreStoriesNotice';
import { ChannelPerformance, RankingsDetail } from '../components/results/ResultsDetails';
import WorkAndNextStep from '../components/results/WorkAndNextStep';

export default function ResultsPage() {
  return (
    <main className="min-h-screen bg-[#0b1423] pt-20">
      <div className="mx-auto max-w-7xl px-4 pt-14 sm:px-6 sm:pt-20 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#f8b86a]">Jelly Local results</p>
        <h1 className="mt-4 max-w-4xl text-4xl font-black leading-tight tracking-tight text-white sm:text-6xl">
          Real local activity. <span className="text-[#3fc0fa]">A closer look at 90&apos;s Nails.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-300">
          See the customer actions, search visibility and consistent marketing work recorded in this nail salon’s dashboard.
        </p>
      </div>
      <NinetiesNailsCaseStudy />
      <ChannelPerformance />
      <RankingsDetail />
      <WorkAndNextStep />
      <MoreStoriesNotice />
    </main>
  );
}